import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AuthorizedSignerDetailFragmentDoc } from '../fragments/authorizedSignerDetail.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAuthorizedSignerMutationVariables = Types.Exact<{
  authorized_signer_id: Types.Scalars['ID'];
  name: Types.Scalars['String'];
  allowed_item_location_ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type UpdateAuthorizedSignerMutation = { __typename?: 'Mutation', updateAuthorizedSigner: { __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, can_use_all_item_locations: boolean, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string }> | null, event_account: { __typename?: 'EventAccount', item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, can_be_deleted: boolean, event_account_id?: string | null }> | null } } };


export const UpdateAuthorizedSignerDocument = gql`
    mutation UpdateAuthorizedSigner($authorized_signer_id: ID!, $name: String!, $allowed_item_location_ids: [ID!]) {
  updateAuthorizedSigner(
    authorized_signer_id: $authorized_signer_id
    name: $name
    allowed_item_location_ids: $allowed_item_location_ids
  ) {
    ...AuthorizedSignerDetail
  }
}
    ${AuthorizedSignerDetailFragmentDoc}`;
export type UpdateAuthorizedSignerMutationFn = Apollo.MutationFunction<UpdateAuthorizedSignerMutation, UpdateAuthorizedSignerMutationVariables>;

/**
 * __useUpdateAuthorizedSignerMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizedSignerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizedSignerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizedSignerMutation, { data, loading, error }] = useUpdateAuthorizedSignerMutation({
 *   variables: {
 *      authorized_signer_id: // value for 'authorized_signer_id'
 *      name: // value for 'name'
 *      allowed_item_location_ids: // value for 'allowed_item_location_ids'
 *   },
 * });
 */
export function useUpdateAuthorizedSignerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthorizedSignerMutation, UpdateAuthorizedSignerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthorizedSignerMutation, UpdateAuthorizedSignerMutationVariables>(UpdateAuthorizedSignerDocument, options);
      }
export type UpdateAuthorizedSignerMutationHookResult = ReturnType<typeof useUpdateAuthorizedSignerMutation>;
export type UpdateAuthorizedSignerMutationResult = Apollo.MutationResult<UpdateAuthorizedSignerMutation>;
export type UpdateAuthorizedSignerMutationOptions = Apollo.BaseMutationOptions<UpdateAuthorizedSignerMutation, UpdateAuthorizedSignerMutationVariables>;